// removed by extract-text-webpack-plugin
module.exports = {"mask":"_2wEk9WrxzxU2DhaO9ElHBQ_0","mapClass":"OwEjAkmUhgfJbSVHyAoy8_0","footerClass":"_1u3-VHuet4xqIUNoWGjPKl_0"};


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/prod-isrs-frontend-mb_master/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","importLoaders":1,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5039c516","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/views/MapHolder.vue
// module id = 232
// module chunks = 0